import { render, staticRenderFns } from "./DeclarationOthers.vue?vue&type=template&id=c8e5b090"
import script from "./DeclarationOthers.vue?vue&type=script&lang=js"
export * from "./DeclarationOthers.vue?vue&type=script&lang=js"
import style0 from "./DeclarationOthers.vue?vue&type=style&index=0&id=c8e5b090&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports